import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	bottom: 0;
	padding: 1rem 0;
	gap: 1.29rem;
`;

export const Divider = styled.div`
	display: flex;
	align-self: stretch;
	width: 1px;

	background: var(--black-30);
`;
